export default __webpack_public_path__ + "static/media/spectacles-incorrect1.c50e8033.PNG";